module.exports = __webpack_public_path__ + "static/media/filter-icon.40a03ad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter-icon.svg
// module id = 570
// module chunks = 1